import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../../../firebaseConfig';
import { getCurrentSeason } from '../../../data/seasons';

export const useMyStatsTeamData = () => {
  const [teamName, setTeamName] = useState('');
  const [userProfile, setUserProfile] = useState(null);
  const [uid, setUid] = useState(null);
  const [teamId, setTeamId] = useState(null);
  const [teamLogo, setTeamLogo] = useState(null);

  useEffect(() => {
    let active = true;

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!active) return;
      if (!user) {
        setUid(null);
        setUserProfile(null);
        setTeamId(null);
        setTeamLogo(null);
        setTeamName('');
        return;
      }

      setUid(user.uid);

      try {
        const userRef = doc(db, `users/${user.uid}`);
        const userSnap = await getDoc(userRef);
        if (!active || !userSnap.exists()) return;

        const data = userSnap.data();
        setUserProfile(data);

        if (!data.teamId) return;

        setTeamId(data.teamId);
        const teamRef = doc(db, `teams/${data.teamId}`);
        const teamSnap = await getDoc(teamRef);
        if (!active || !teamSnap.exists()) return;

        const teamData = teamSnap.data();
        setTeamLogo(teamData.logo || null);
        setTeamName(teamData.name || '');
      } catch (err) {
        console.error('Failed to fetch team data:', err);
      }
    });

    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const currentSeason = getCurrentSeason();
    const loadSeasonTeamInfo = async () => {
      if (!teamId) return;
      try {
        const configRef = doc(db, `teams/${teamId}/configurations/stats`);
        const configSnap = await getDoc(configRef);
        if (!configSnap.exists()) return;

        const config = configSnap.data();
        if (!config?.seasons?.[currentSeason]) return;

        const seasonConfig = config.seasons[currentSeason];
        if (seasonConfig.teamName) {
          setTeamName(seasonConfig.teamName);
        }
        if (seasonConfig.teamLogo) {
          setTeamLogo(seasonConfig.teamLogo);
        }
      } catch (err) {
        console.error('Failed to load season team info:', err);
      }
    };

    loadSeasonTeamInfo();
  }, [teamId]);

  return {
    teamName,
    userProfile,
    uid,
    teamId,
    teamLogo,
    setUserProfile,
    setTeamLogo,
  };
};
